import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import {
  organizationJsonLd,
  websiteJsonLd,
  professionalServiceJsonLd,
} from "@/seo/jsonLd";
import { useTranslation } from "@/i18n/useTranslation";
import { stripLocalePrefix } from "@/i18n/localePath";
import { ARTICLE_SLUGS, STATIC_ROUTES } from "@/seo/routes";

const indexableBasePaths = new Set(STATIC_ROUTES.map((route) => route.path));
const articleBasePaths = new Set(ARTICLE_SLUGS.map((slug) => `/insights/${slug}`));

/**
 * Site-wide JSON-LD: mounted once at the App root.
 * Defines the Vert AI entity, website, and professional-service node
 * that other per-page schemas reference via @id.
 */
const SiteJsonLd = () => {
  const { locale } = useTranslation();
  const { pathname } = useLocation();
  const basePath = stripLocalePrefix(pathname).replace(/\/+$/, "") || "/";

  if (!indexableBasePaths.has(basePath) && !articleBasePaths.has(basePath)) {
    return null;
  }

  const isVerificationFunnelRoute = basePath === "/services/ai-verification-review"
    || basePath === "/resources/sample-ai-verification-review";
  const blocks = isVerificationFunnelRoute
    ? [organizationJsonLd(locale)]
    : [
        organizationJsonLd(locale),
        websiteJsonLd(locale),
        professionalServiceJsonLd(locale),
      ];
  return (
    <Helmet>
      {blocks.map((block, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(block)}
        </script>
      ))}
    </Helmet>
  );
};

export default SiteJsonLd;
